var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_cof.js
// module id = 35
// module chunks = 0